import styled from 'styled-components'

export const ImagesContainer = styled.div`
  display: grid;
  grid-template-columns: 300px 300px;
  grid-template-rows: repeat(2, 300px);
  grid-gap: 10px;
  width: 610px;
`

export const HelpText = styled.div`
  margin: 20px 40px;
`
